<template>
  <div class="foot">
    <div class="container">
      <div class="main" v-if="isMobile">
        <div>
          <img :src="code" alt="" />
        </div>
        <div>
          <div>南京吉冉软件有限公司</div>
          <div>400-6919-019</div>
          <div>www.geezhi.com.cn</div>
          <div>南京市浦口区星火路软件大厦B座6楼</div>
          <div>
            <a class="link" href="https://beian.miit.gov.cn/" target="_blank"
              >苏ICP备 18052121号-2</a
            >
          </div>
        </div>
      </div>
      <div class="main" v-else>
        <div>
          南京吉冉软件有限公司 | 400-6919-019 www.geezhi.com.cn
          南京市浦口区星火路软件大厦B座6楼
          <a class="link" href="https://beian.miit.gov.cn/" target="_blank"
            >苏ICP备 18052121号-2</a
          >
        </div>
        <div>
          <img :src="code" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import code from "@/assets/images/code.png";
export default {
  data() {
    return {
      code,
    };
  },
};
</script>

<style scoped>
.foot {
  background-color: #2f56ce;
  height: 240px;
}
.main {
  height: 100px;
  margin-top: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
}
.link {
  color: #fff;
}
/*  */
.mb .foot {
  height: 180px;
}
.mb img {
  height: 80px;
  margin-right: 10px;
}
.mb .main {
  border: none;
  font-size: 13px;
  margin-top: 40px;
}
</style>